import React from "react";

const NoOptionsAddButton = (props) => {

    const {
        onHandleOpenAddNewValueModal
    } = props;

    return (
        <>
            <p onClick={() => onHandleOpenAddNewValueModal()} className="no-options-add-button">Add new value</p>
        </>
    )
}
export default NoOptionsAddButton;